"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardExternalRoute = exports.WizardAppRoute = exports.WizardRoute = void 0;
var WizardRoute;
(function (WizardRoute) {
    WizardRoute["BASE_ROUTE"] = "/";
    WizardRoute["CONFIGURE_DASHBOARD"] = "configure";
    WizardRoute["CONFIGURE_LABELS"] = "labels/:reportRunId";
    WizardRoute["SELECT_PACKAGE"] = "package/:reportRunId";
    WizardRoute["PREVIEW_REPORT"] = "preview/:reportRunId";
    WizardRoute["SHARE_DASHBOARD"] = "share/:reportId";
})(WizardRoute || (exports.WizardRoute = WizardRoute = {}));
;
var WizardAppRoute;
(function (WizardAppRoute) {
    WizardAppRoute["LOCATION_INSIGHTS"] = "locationInsights";
    WizardAppRoute["CAMPAIGN_INSIGHTS"] = "campaignInsights";
    WizardAppRoute["CONSUMER_INSIGHTS"] = "consumerInsights";
    WizardAppRoute["MARKET_INSIGHTS"] = "marketInsights";
})(WizardAppRoute || (exports.WizardAppRoute = WizardAppRoute = {}));
var WizardExternalRoute;
(function (WizardExternalRoute) {
    WizardExternalRoute["INTERNAL_TOOLS"] = "/internalTools";
})(WizardExternalRoute || (exports.WizardExternalRoute = WizardExternalRoute = {}));
